/* eslint-disable @angular-eslint/prefer-inject */
import { RequisitionDataService } from '../infrastructure/requisitions/requisition.data.service';
import {
    RequisitionCreate,
    RequisitionDto,
    RequisitionRead,
    RequisitionSearchParams,
} from '../entities/requisition.dto';
import { RequisitionStore } from '../infrastructure/requisitions/requisition.store';
import { inject, Injectable } from '@angular/core';
import { AbstractManageEntityFacade } from '@pf/shared-services';
import { RequisitionMapper } from '../infrastructure/requisitions/requisition.mapper';
import { BuildChangeTrackingFacadeFactory } from '@pf/shared/util-platform';
import { IManageEntityRoutes, IQueryParams } from '@pf/shared-common';
import { map, Observable, tap } from 'rxjs';
import { ResourceAuth } from '@control-tower/platform-wms';
import { WarehouseFacade } from './warehouse.facade';

@Injectable()
export class RequisitionFacade extends AbstractManageEntityFacade<
    RequisitionDto,
    RequisitionRead,
    RequisitionCreate,
    RequisitionSearchParams
> {
    private readonly warehouseFacade = inject(WarehouseFacade);
    nameField: keyof RequisitionDto = 'status';

    constructor(
        dataService: RequisitionDataService,
        store: RequisitionStore,
        mapper: RequisitionMapper
    ) {
        super(
            dataService,
            null as unknown as IManageEntityRoutes,
            store,
            mapper
        );
    }

    override getDefaultSearchParams$(
        params: IQueryParams<RequisitionDto>
    ): Observable<IQueryParams<RequisitionDto>> {
        return this.warehouseFacade.addDefaultWarehouseParam(params);
    }

    override applyResourceAuth(body: RequisitionCreate) {
        const locationId = this.warehouseFacade.active?.location?.id;
        body.resourceAuth = {
            locations: locationId ? [locationId] : [],
        } as ResourceAuth;
    }

    changeTrackingFactory = BuildChangeTrackingFacadeFactory(
        this.dataService,
        this.nameField
    );

    textSearchFilter(
        searchText: string
    ): Partial<Record<keyof RequisitionDto, string>> {
        return { status: searchText };
    }

    getByPoId$(purchaseOrderHeaderId: string) {
        return this.oneTimeSearch$({
            pageIndex: 1,
            pageSize: 1,
            filters: {
                purchaseOrder: purchaseOrderHeaderId,
            },
        }).pipe(
            map(result => result.data?.[0] ?? null),
            tap(requisition => {
                if (requisition) {
                    this.store.add(requisition, false);
                }
            })
        );
    }
}
